export default __webpack_public_path__ + "static/media/fillPatternSemiTop.f6476865.svg";